import React, { useEffect, useRef, useState } from "react";
import { classes } from "../../../core/data/json/classes";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import { activeList } from "../../../core/common/selectoption/selectoption";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import { Link, useNavigate } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";
import { _get, _post, _put } from "../../Utils/Helper";
import { toast } from "react-toastify";
import NewDatatable from "../../../core/common/dataTable/NewDatatable";
import { Button, Col, Input, Modal, Row, Switch } from "antd";
import Password from "antd/es/input/Password";
import { json } from "stream/consumers";
const SchoolList = () => {
  const _form = {
    query_type: "update",
    status: "suspended",
    id: "",
    school_name: "",
  };
  const _branchAdmin= {
    name: "",
    email: "",
    Password: "",
    username: "",
  };

  const [form, setForm] = useState(_form);

  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isBranchModalVisible, setIsBranchModalVisible] = useState(false);
  const [branchAddress, setBranchAddress] = useState("");
  const [branch_name, setBranch_name] = useState("");
  const [branchAdmin, setBranchAdmin] = useState(_branchAdmin);

  const handleChange = (e: any) => {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  };
  const navigate = useNavigate();
  const [new_data, setNewData] = useState([]);

  const getSchools = () => {
    _get(
      "schools?query_type=select",
      (res) => {
        console.log(res);
        setNewData(res.data);
      },
      (err) => {
        // setLoading(false)
        console.log(err);
      }
    );
  };
  const [selectedSchool, setSelectedSchool] = useState<{
    school_motto: string;
    state: string;
    lga: string;
    primary_contact_number: string;
    secondary_contact_number: string;
    email_address: string;
    school_url: string;
    school_master: number;
    express_finance: number;
    cbt_center: number;
    result_station: number;
    nursery_section: number;
    primary_section: number;
    junior_secondary_section: number;
    senior_secondary_section: number;
    islamiyya: number;
    tahfiz: number;
    school_name: string;
    short_name: string;
    address: string;
    school_id: string;
    status: string;
    branch_name?: string;
    branch_address?: string;
  } | null>(null);

  const handleSuspend = (id: string, newStatus: string) => {
    const payload = {
      query_type: "update",
      status: newStatus,
      school_id: id,
    };

    _post(
      "school-setup",
      payload,
      (res) => {
        if (res.success) {
          toast.success(`School ${newStatus} successfully`);
          getSchools();
        }
      },
      (err) => {
        toast.error(err.message || "Error updating status");
      }
    );
  };

  useEffect(() => {
    getSchools();
  }, []);

  // Handle toggle switches
  const handleToggle = (field: string, value: boolean) => {
    setSelectedSchool((prev: any) => ({
      ...prev,
      [field]: value ? 1 : 0,
    }));
  };

  const routes = all_routes;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  // Handle edit school
  const handleEdit = (school: any) => {
    setSelectedSchool(school);
    setIsEditModalVisible(true);
  };

  const handleEditSubmit = () => {
    if (!selectedSchool) return;

    const payload = {
      query_type: "update_school",
      school_id: selectedSchool.school_id,
      school_name: selectedSchool.school_name,
      short_name: selectedSchool.short_name,
      school_motto: selectedSchool.school_motto,
      state: selectedSchool.state,
      lga: selectedSchool.lga,
      address: selectedSchool.address,
      primary_contact_number: selectedSchool.primary_contact_number,
      secondary_contact_number: selectedSchool.secondary_contact_number,
      email_address: selectedSchool.email_address,
      school_master: selectedSchool.school_master,
      express_finance: selectedSchool.express_finance,
      cbt_center: selectedSchool.cbt_center,
      result_station: selectedSchool.result_station,
      nursery_section: selectedSchool.nursery_section,
      primary_section: selectedSchool.primary_section,
      junior_secondary_section: selectedSchool.junior_secondary_section,
      senior_secondary_section: selectedSchool.senior_secondary_section,
      islamiyya: selectedSchool.islamiyya,
      tahfiz: selectedSchool.tahfiz,
    };

    _put(
      `update-school/${selectedSchool.school_id}`,
      payload,
      (res) => {
        if (res.success) {
          toast.success("School updated successfully");
          setIsEditModalVisible(false);
          getSchools();
        }
      },
      (err) => {
        toast.error(err.message || "Error updating school");
      }
    );
  };

  // Handle add branch
  const handleAddBranch = (schoolId: string, record: any) => {
    setSelectedSchool({
     ...record
    });
    setIsBranchModalVisible(true);
  };

  const handleBranchSubmit = () => {
    if (!selectedSchool) return;

    const payload = {
      query_type: "create",
      school_id: selectedSchool.school_id,
      branch_name: branch_name,
      location: branchAddress,
      short_name: selectedSchool.short_name,
      status: "Active",
    };

    console.log(payload);

    _post(
      "branches",
      payload,
      (res) => {
        if (res.success) {
          toast.success("Branch added successfully");
          setIsBranchModalVisible(false);
          setBranchAddress("");
          getSchools();
        }
      },
      (err) => {
        toast.error(err.message || "Error adding branch");
      }
    );
  };
  const columns = [
    {
      title: "ID",
      dataIndex: "school_id",
      render: (text: string, record: any, index: number) => (
        <>
          <Link to="#" className="link-primary">
            {text}
          </Link>
        </>
      ),
    },
    {
      title: "School Name",
      dataIndex: "school_name",
    },
    {
      title: "Abbreviation",
      dataIndex: "short_name",
    },
    {
      title: "Address",
      dataIndex: "address",
    },
    {
      title: "School URL",
      dataIndex: "school_url",
      render: (text: string, record: any) => (
        <>
          {text ? (
            <a
              href={text}
              target="_blank"
              rel="noopener noreferrer"
              className="link-primary"
            >
              {text}
            </a>
          ) : (
            <span>No URL</span>
          )}
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <>
          {text === "active" ? (
            <span className="badge badge-soft-success d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              {text}
            </span>
          ) : (
            <span className="badge badge-soft-danger d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              {text}
            </span>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text: string, record: any) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    // data-bs-toggle="modal"
                    // data-bs-target="#edit_class"
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#suspend-modal"
                    onClick={() =>
                      setSelectedSchool({
                        school_id: record.school_id,
                        status: record.status,
                        school_name: record.school_name,
                        short_name: record.short_name,
                        address: record.address,
                        school_motto: "",
                        state: "",
                        lga: "",
                        primary_contact_number: "",
                        secondary_contact_number: "",
                        email_address: "",
                        school_url: "",
                        school_master: 0,
                        express_finance: 0,
                        cbt_center: 0,
                        result_station: 0,
                        nursery_section: 0,
                        primary_section: 0,
                        junior_secondary_section: 0,
                        senior_secondary_section: 0,
                        islamiyya: 0,
                        tahfiz: 0,
                      })
                    }
                  >
                    <i className="ti ti-suspend me-2" />
                    {record.status === "active" ? "Suspend" : "Activate"}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <Button type="link" onClick={() => handleEdit(record)}>
            Edit
          </Button>
          <Button
            type="link"
            onClick={() =>
              handleSuspend(
                record.school_id,
                record.status === "active" ? "suspended" : "active"
              )
            }
          >
            {record.status === "active" ? "Suspend" : "Activate"}
          </Button>
          <Button
            type="link"
            onClick={() => handleAddBranch(record.school_id, record)}
          >
            Add Branch
          </Button>
        </div>
      ),
    },
  ];
  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              {/* <h3 className="page-title mb-1">School List</h3> */}
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {/* <TooltipOption /> */}
              <div className="mb-2">
                <Link to={routes.schoolSetup} className="btn btn-primary">
                  <i className="ti ti-square-rounded-plus-filled me-2" />
                  Add New School
                </Link>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h2 className="mb-3">List of Schools</h2>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  {/* <PredefinedDateRanges /> */}
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              <NewDatatable
                columns={columns}
                dataSource={new_data}
                Selection={false}
                withSearch={true}
                pageSize={0}
                withPagination={false}
              />
            </div>
          </div>
        </div>
      </div>
      <>
        {/* suspend schools */}
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete this School, this cant be undone once you
                    delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="modal fade" id="suspend-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-alert-circle fs-5" />
                  </span>
                  <h4>
                    Confirm{" "}
                    {selectedSchool?.status === "active"
                      ? "Suspension"
                      : "Activation"}
                  </h4>
                  <p>
                    You want to{" "}
                    {selectedSchool?.status === "active"
                      ? "suspend"
                      : "activate"}{" "}
                    this school
                  </p>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        if (selectedSchool) {
                          handleSuspend(
                            selectedSchool.school_id,
                            selectedSchool.status === "active"
                              ? "suspended"
                              : "active"
                          );
                        }
                      }}
                    >
                      Yes,{" "}
                      {selectedSchool?.status === "active"
                        ? "Suspend"
                        : "Activate"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Edit School Modal */}
        <Modal
          title="Edit School"
          visible={isEditModalVisible}
          onCancel={() => setIsEditModalVisible(false)}
          footer={[
            <Button key="cancel" onClick={() => setIsEditModalVisible(false)}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handleEditSubmit}>
              Save Changes
            </Button>,
          ]}
          width={800}
        >
          {selectedSchool && (
            <div>
              <Row gutter={16}>
                <Col span={8}>
                  <Input
                    // label="School ID"
                    value={selectedSchool.school_id}
                    disabled
                    className="mb-3"
                  />
                </Col>
                <Col span={8}>
                  <Input
                    // label="School Name"
                    value={selectedSchool.school_name}
                    disabled
                    onChange={(e) =>
                      setSelectedSchool({
                        ...selectedSchool,
                        school_name: e.target.value,
                      })
                    }
                    className="mb-3"
                  />
                </Col>
                <Col span={8}>
                  <Input
                    // label="Abbreviation"
                    value={selectedSchool.short_name}
                    disabled
                    onChange={(e) =>
                      setSelectedSchool({
                        ...selectedSchool,
                        short_name: e.target.value,
                      })
                    }
                    className="mb-3"
                  />
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Input
                    // label="School Motto"
                    value={selectedSchool.school_motto}
                    onChange={(e) =>
                      setSelectedSchool({
                        ...selectedSchool,
                        school_motto: e.target.value,
                      })
                    }
                    className="mb-3"
                  />
                </Col>
                <Col span={8}>
                  <Input
                    // label="State"
                    value={selectedSchool.state}
                    onChange={(e) =>
                      setSelectedSchool({
                        ...selectedSchool,
                        state: e.target.value,
                      })
                    }
                    className="mb-3"
                  />
                </Col>
                <Col span={8}>
                  <Input
                    // label="LGA"
                    value={selectedSchool.lga}
                    onChange={(e) =>
                      setSelectedSchool({
                        ...selectedSchool,
                        lga: e.target.value,
                      })
                    }
                    className="mb-3"
                  />
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Input
                    // label="Address"
                    value={selectedSchool.address}
                    onChange={(e) =>
                      setSelectedSchool({
                        ...selectedSchool,
                        address: e.target.value,
                      })
                    }
                    className="mb-3"
                  />
                </Col>
                <Col span={8}>
                  <Input
                    // label="Primary Contact"
                    value={selectedSchool.primary_contact_number}
                    onChange={(e) =>
                      setSelectedSchool({
                        ...selectedSchool,
                        primary_contact_number: e.target.value,
                      })
                    }
                    className="mb-3"
                  />
                </Col>
                <Col span={8}>
                  <Input
                    // label="Secondary Contact"
                    value={selectedSchool.secondary_contact_number || ""}
                    onChange={(e) =>
                      setSelectedSchool({
                        ...selectedSchool,
                        secondary_contact_number: e.target.value,
                      })
                    }
                    className="mb-3"
                  />
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Input
                    // label="Email Address"
                    value={selectedSchool.email_address}
                    onChange={(e) =>
                      setSelectedSchool({
                        ...selectedSchool,
                        email_address: e.target.value,
                      })
                    }
                    className="mb-3"
                  />
                </Col>
                <Col span={8}>
                  <Input
                    // label="School URL"
                    value={selectedSchool.school_url}
                    disabled
                    className="mb-3"
                  />
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <div className="mb-3">
                    <label>School Master</label>
                    <Switch
                      checked={selectedSchool.school_master === 1}
                      onChange={(checked) =>
                        handleToggle("school_master", checked)
                      }
                    />
                  </div>
                </Col>
                <Col span={8}>
                  <div className="mb-3">
                    <label>Express Finance</label>
                    <Switch
                      checked={selectedSchool.express_finance === 1}
                      onChange={(checked) =>
                        handleToggle("express_finance", checked)
                      }
                    />
                  </div>
                </Col>
                <Col span={8}>
                  <div className="mb-3">
                    <label>CBT Center</label>
                    <Switch
                      checked={selectedSchool.cbt_center === 1}
                      onChange={(checked) =>
                        handleToggle("cbt_center", checked)
                      }
                    />
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <div className="mb-3">
                    <label>Result Station</label>
                    <Switch
                      checked={selectedSchool.result_station === 1}
                      onChange={(checked) =>
                        handleToggle("result_station", checked)
                      }
                    />
                  </div>
                </Col>
                <Col span={8}>
                  <div className="mb-3">
                    <label>Nursery Section</label>
                    <Switch
                      checked={selectedSchool.nursery_section === 1}
                      onChange={(checked) =>
                        handleToggle("nursery_section", checked)
                      }
                    />
                  </div>
                </Col>
                <Col span={8}>
                  <div className="mb-3">
                    <label>Primary Section</label>
                    <Switch
                      checked={selectedSchool.primary_section === 1}
                      onChange={(checked) =>
                        handleToggle("primary_section", checked)
                      }
                    />
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <div className="mb-3">
                    <label>Junior Secondary</label>
                    <Switch
                      checked={selectedSchool.junior_secondary_section === 1}
                      onChange={(checked) =>
                        handleToggle("junior_secondary_section", checked)
                      }
                    />
                  </div>
                </Col>
                <Col span={8}>
                  <div className="mb-3">
                    <label>Senior Secondary</label>
                    <Switch
                      checked={selectedSchool.senior_secondary_section === 1}
                      onChange={(checked) =>
                        handleToggle("senior_secondary_section", checked)
                      }
                    />
                  </div>
                </Col>
                <Col span={8}>
                  <div className="mb-3">
                    <label>Islamiyya</label>
                    <Switch
                      checked={selectedSchool.islamiyya === 1}
                      onChange={(checked) => handleToggle("islamiyya", checked)}
                    />
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <div className="mb-3">
                    <label>Tahfiz</label>
                    <Switch
                      checked={selectedSchool.tahfiz === 1}
                      onChange={(checked) => handleToggle("tahfiz", checked)}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Modal>

        {/* Add Branch Modal */}
        <Modal
          title={`Add Branch ${selectedSchool?.school_name}`}
          visible={isBranchModalVisible}
          onCancel={() => setIsBranchModalVisible(false)}
          footer={[
            <Button key="cancel" onClick={() => setIsBranchModalVisible(false)}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handleBranchSubmit}>
              Add Branch
            </Button>,
          ]}
        >
          {/* {JSON.stringify(selectedSchool?.short_name)} */}
          <div style={{ marginBottom: "10px" }}>
            <label style={{ fontWeight: "bold" }}>Branch Name</label>
            <Input
              placeholder="Enter branch name"
              value={branch_name}
              onChange={(e) => setBranch_name(e.target.value)}
            />
          </div>

          <div style={{ marginBottom: "10px" }}>
            <label style={{ fontWeight: "bold" }}>Branch Address</label>
            <Input
              placeholder="Enter branch address"
              value={branchAddress}
              onChange={(e) => setBranchAddress(e.target.value)}
            />
          </div>
        </Modal>
      </>
    </div>
  );
};

export default SchoolList;
